class UniverseSelector extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.Init();
    this.AddEventListeners();
  }

  Init() {
    const settings = this.hasAttribute('data-universe-settings') ? { ...JSON.parse(this.getAttribute('data-universe-settings')) } : null;

    if (!settings) return;

    this.settings = {
      ...settings
    };
  }

  AddEventListeners() {
    this.Click = this.Click.bind(this);
    this.Change = this.Change.bind(this);

    this.addEventListener('click', this.Click);
    document.addEventListener('universe:changed', this.Change)
  }

  async Change(event) {

    const universe_val = event.detail.universe;
    const bool = universe_val == this.getAttribute('data-universe');

    this.setAttribute('aria-checked', bool);
  }

  async Click() {
    await fetch(`${ theme.routes.cartUpdate }`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: this.settings
      }),
    });

    if (this.hasAttribute('data-universe-url')) {
      window.location.href = this.getAttribute('data-universe-url');
    }
    else {
      document.body.setAttribute('data-universe', this.getAttribute('data-universe'));
      document.dispatchEvent(new CustomEvent('universe:changed', {
        bubbles: true,
        detail: {
          universe: this.getAttribute('data-universe')
        }
      }))
    }
  }
}

customElements.define('universe-selector', UniverseSelector);